// extracted by mini-css-extract-plugin
module.exports = {"root":"NotificationForm_root__uIEFv","input":"NotificationForm_input__2gfsb"};